type Role = string

export interface DataEntries {
  label: string
  to?: string
  roles?: Role[]
  collapse?: boolean
  dataEntries?: DataEntries[]
}

export const entries = (): DataEntries[] => {
  return [
    {
      label: 'Perfil',
      collapse: false,
      dataEntries: [
        {
          label: 'Minha conta',
          to: '/admin/home'
        },
        {
          label: 'Segurança',
          to: '/admin/seguranca'
        },
        {
          label: 'Meus dados',
          to: '/admin/meu-perfil'
        }
      ]
    }
  ]
}

export const entriesMobile = (): DataEntries[] => {
  const _menus = []
  entries().forEach(menu => {
    _menus.push(...menu.dataEntries)
  })
  return _menus
}
